










































import { Component, Vue } from 'vue-property-decorator';

import { generalInfo, prevMeetups, sns } from '@/store/fifth/store';

@Component({})
export default class Footer extends Vue {
  private generalInfo = generalInfo;
  private prevMeetups = prevMeetups;
  private sns = sns;
}
